/**
 * « Vous explorez une autre spécialité — lecture seule » (PT-74).
 *
 * The gates hide the buttons; this says why they are gone. Without it, a reader visiting
 * another speciality would simply find the pencil, the aggregation and the EuroSpine step missing,
 * with nothing on screen to tell them whether it is a right they lack or a dossier that is not
 * ready — two states the same absence would otherwise describe.
 */
import { Eye } from "lucide-react";
import { Trans } from "@lingui/macro";
import { useLingui } from "@lingui/macro";
import { usePreviewView } from "@app/zustand/preview-view";
import { useEffectiveSpecialite } from "@app/utils/use-effective-specialite";
import { useReadonlyScope } from "@app/utils/use-readonly-scope";
import { specialityShortLabel } from "@app/utils/speciality";

export default function ReadonlyScopeBanner() {
  const { t } = useLingui();
  const setSpecialite = usePreviewView((state) => state.setSpecialite);
  const effectiveSpecialite = useEffectiveSpecialite();
  const readonlyScope = useReadonlyScope();

  if (!readonlyScope) return null;

  return (
    <div className="flex items-center justify-between gap-3 bg-blue-50 border-b border-primary/20 px-4 py-2 text-sm text-blue-900">
      <span className="flex items-center gap-2">
        <Eye className="h-4 w-4 text-primary shrink-0" />
        <Trans>
          Vous explorez la spécialité{" "}
          <strong>
            {effectiveSpecialite
              ? specialityShortLabel(effectiveSpecialite, t)
              : ""}
          </strong>{" "}
          en lecture seule.
        </Trans>
      </span>
      <button
        type="button"
        onClick={() => setSpecialite(null)}
        className="font-medium text-primary hover:text-primary/80 whitespace-nowrap"
      >
        <Trans>Revenir à mon périmètre</Trans>
      </button>
    </div>
  );
}
